/* eslint-disable @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-argument,@typescript-eslint/no-floating-promises,@typescript-eslint/no-unsafe-return */
// noinspection JSIgnoredPromiseFromCall
import type { Middleware } from '@reduxjs/toolkit';
import { isRejectedWithValue } from '@reduxjs/toolkit';

import { notifications } from '@mantine/notifications';

import { checkAuthAction } from '@/store/api-actions/renew-auth';

import { store } from '@/store';

export const rtkQueryErrorLogger: Middleware = () => (next) => (action) => {
	if (isRejectedWithValue(action)) {
		switch (action?.payload.status) {
			case 400:
				// action.payload.data?.context?.message
				// 	? message.warning(action.payload?.data?.context?.message)
				// 	: message.error('Проверьте введенные данные и попробуйте снова');
				notifications.show({
					title: 'Ошибка',
					message:
						action.payload?.data?.context?.message ??
						'Проверьте введенные данные и попробуйте снова',
				});
				break;
			case 401:
				store.dispatch(checkAuthAction());
				break;
			case 403:
				// action.payload.data?.context?.message
				// 	? message.warning(action.payload?.data?.context?.message)
				// 	: message.warning('Вы не уполномочены совершать операции с запрошенным ресурсом');
				notifications.show({
					title: 'Ошибка',
					message:
						action.payload?.data?.context?.message ??
						'Вы не уполномочены совершать операции с запрошенным ресурсом',
				});
				break;
			case 404:
				// action.payload.data?.context?.message
				// 	? message.warning(action.payload?.data?.context?.message)
				// 	: message.warning('Запрашиваемая страница или ресурс не найден');
				notifications.show({
					title: 'Ошибка',
					message:
						action.payload?.data?.context?.message ?? 'Запрашиваемая страница или ресурс не найден',
				});
				break;
			case 409:
				// action.payload.data?.context?.message
				// 	? message.warning(action.payload?.data?.context?.message)
				// 	: message.warning('Данный объект уже забронирован');
				notifications.show({
					title: 'Ошибка',
					message: action.payload?.data?.context?.message ?? 'Данный объект уже забронирован',
				});
				break;
			default:
				// action.payload.data?.context?.message
				// 	? message.warning(action.payload?.data?.context?.message)
				// 	: message.error('Ошибка клиент-серверного взаимодействия');
				notifications.show({
					title: 'Ошибка',
					message:
						action.payload?.data?.context?.message ?? 'Ошибка клиент-серверного взаимодействия',
				});
				break;
		}
	}

	return next(action);
};
